//import Data from "src/tutorialData.json";
import { Button, Modal, Stepper, Title } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
//import { writeFile } from "fs/promises";
import Image from "next/image";
import { type FC, memo, useState } from "react";
import { usePatchTutorialMutation } from "src/service/TutorialApi";

import styles from "./Tutorial.module.scss";

const Tutorial: FC<{
  image: string[];
  title: string;
}> = ({ image, title }) => {
  const matches = useMediaQuery("(max-width: 768px)");
  const [active, setActive] = useState(0);
  const [isOpened, setIsOpened] = useState(true);
  const [PatchTutorial] = usePatchTutorialMutation();
  //const [jsonData, setJsonData] = useState(Data);

  const titleConvert = () => {
    if (title === "ようこそTANQ BASEへ！") {
      return "マイページ";
    } else {
      return title;
    }
  };

  const endTutorialTitle = async () => {
    switch (title) {
      case "ようこそTANQ BASEへ！":
        await PatchTutorial({ login: true });
        break;
      case "マイページ":
        await PatchTutorial({ myPage: true });
        break;
      case "セッション":
        await PatchTutorial({ session: true });
        break;
      case "フムフム":
        await PatchTutorial({ fumufumu: true });
        break;
      case "クローゼット":
        await PatchTutorial({ closet: true });
        break;
      case "部室":
        await PatchTutorial({ clubroom: true });
        break;
      case "マップ":
        await PatchTutorial({ map: true });
        break;
      case "メンバー 一覧":
        await PatchTutorial({ member: true });
        break;
      case "ランキング":
        await PatchTutorial({ ranking: true });
        break;
      case "ステータス":
        await PatchTutorial({ status: true });
        break;
      case "ミッション":
        await PatchTutorial({ mission: true });
        break;
      case "バッジ":
        await PatchTutorial({ badge: true });
        break;
      case "ショップ":
        await PatchTutorial({ shop: true });
        break;
      case "スタイル":
        await PatchTutorial({ style: true });
        break;
    }
  };

  return (
    <div>
      <Modal
        opened={isOpened}
        onClose={() => {
          endTutorialTitle();
        }}
        size={"80%"}
        fullScreen={matches ? true : false}
        withCloseButton={false}
        closeOnClickOutside={false}
      >
        <Title order={2} className={styles.titleWrap}>
          {title}
        </Title>
        <Stepper
          className={styles.stepperWrap}
          active={active}
          onStepClick={setActive}
        >
          {image.map((item, i) => {
            return (
              <Stepper.Step key={i} allowStepSelect={false}>
                <div className={styles.tutorialWrap}>
                  <Image
                    className={styles.tutorialImageWrap}
                    src={item}
                    alt="チュートリアル画像"
                    width={480}
                    height={450}
                  />
                </div>
              </Stepper.Step>
            );
          })}
        </Stepper>
        <div className={styles.nextButtonWrap}>
          <Button
            className={styles.nextButton}
            onClick={() => {
              if (active < image.length - 1) {
                setActive(active + 1);
              } else {
                endTutorialTitle();
                setIsOpened(false);
                if (title === "部室") {
                  window.history.back();
                  window.location.assign(process.env.NEXT_PUBLIC_METALIFE_URL);
                }
              }
            }}
          >
            {active < image.length - 1 ? "次へ" : titleConvert() + "へ"}
          </Button>
        </div>
        <div className={styles.skipButtonWrap}>
          <Button
            variant="subtle"
            color="dark"
            onClick={() => {
              endTutorialTitle();
              setIsOpened(false);
              if (title === "部室") {
                window.history.back();
                window.location.assign(process.env.NEXT_PUBLIC_METALIFE_URL);
              }
            }}
            display={active < image.length - 1 ? "inline-block" : "none"}
          >
            スキップ
          </Button>
        </div>
      </Modal>
    </div>
  );
};
export const TutorialMemo = memo(Tutorial);
